import React from 'react';

const brands = ['NIKE', 'ADIDAS', 'PUMA', 'H&M', 'ZARA', 'LEVIS'];

export default function BrandStrip() {
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-6 mt-16">
      <div className="rounded-[28px] border border-slate-200 bg-white p-8">
        <h3 className="text-center text-sm font-bold tracking-widest uppercase text-slate-500 mb-6">Trusted by 2M+ shoppers</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-8 opacity-60 grayscale">
          {brands.map((brand, idx) => (
            <div key={idx} className="text-center text-slate-800 font-bold text-xl">{brand}</div>
          ))}
        </div>
      </div>
    </div>
  );
}